module.exports = __webpack_public_path__ + "img/108-d0efb3.png";